import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Organization',
    entityNamePlural: 'Organizations',
    entityNameModule: 'admin',
  }), [])
}
